<template>
  <dialog-drag
    :id="id"
    :ref="'dialog-' + id"
    @close="removeDialog"
    @drag-end="dialogDragEnd"
    @drag-start="selectDialog"
    @move="dialogDragEnd"
    :rightSticky="true"
    class="cus-bg-dialog"
    style="top:0;right:0;left:auto"
  >
    <template v-slot:title>
      <v-card-title class="headline white--text px-6 mr-5" primary-title>
        <v-btn
          disabled
          class="mb-1 mr-1 proc-button-style proc-usr drag-drawflow"
          x-small
          height="30"
          width="30"
          color="proc darken-1"
        >
          <icon-svg :size="procIconSize" iconName="proc-usr" />
        </v-btn>
        <font class="text-xl font-bold leading-snug textcolor5--text">
          User
        </font>
        <v-spacer></v-spacer>
        <v-btn class="btn btn-close rounded-xl" :disabled="!$auth.manage" @click="closeComDialog">{{
          $t('btn.common.close')
        }}</v-btn>
      </v-card-title>
    </template>
    <v-form ref="form" lazy-validation class="px-6 mt-5" style="height: 807px; overflow: auto">
      <v-row class="mt-0">
        <v-col cols="12" md="12" class="px-3 py-0">
          <v-label class="pt-2">{{ $t('lbl.dataSource.form.name') }}</v-label>
          <v-autocomplete
            v-model="comId"
            :items="userList"
            :rules="[validationUtils.required]"
            :disabled="!$auth.manage"
            :readonly="isHistory"
            item-value="uc_id"
            item-text="uc_name"
            autofocus
            solo
            @change="changeComponentData()"
          >
          </v-autocomplete>
        </v-col>
        <v-col cols="12" md="12" class="px-3 py-0">
          <v-label>
            <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
            {{ $t('lbl.dataSource.form.type') }}
          </v-label>
          <v-autocomplete
            v-model="saveData.uc_type"
            :rules="[validationUtils.required]"
            :items="types"
            :disabled="!$auth.manage"
            readonly
            solo
          ></v-autocomplete>
        </v-col>
        <v-col cols="12" md="12" class="px-3 py-0">
          <v-label>
            <v-icon x-small class="mr-1">fa fa-asterisk</v-icon>
            {{ $t('lbl.userComponent.addUserComponent.scriptFile') }}
          </v-label>
        </v-col>
        <v-col cols="12" md="10" class="pl-3 pr-2 py-0">
          <v-text-field
            v-model="saveData.uc_file_name"
            :rules="[validationUtils.required]"
            solo
            readonly
          ></v-text-field>
        </v-col>
        <v-col cols="12" md="2" class="py-0 pr-3 pl-2 text-right">
          <v-btn
            class="btn btn-load"
            color="primary"
            @click="openLoadFilePop({ mode: 'Load', filetype: 'script' })"
          >
            {{ $t('btn.mapManager.load') }}
          </v-btn>
        </v-col>
        <v-col v-if="saveData.uc_type == 'C'" cols="12" md="12" class="px-3 py-0">
          <v-row class="ml-0 mr-0 d-block">
            <v-col lg="6" class="pa-0">
              <v-label>{{ $t('lbl.userComponent.addUserComponent.req') }}</v-label>
              <v-icon dense :disabled="!$auth.manage" readonly @click="addRequest()" class="ml-3">
                mdi-plus
              </v-icon>
            </v-col>
          </v-row>
        </v-col>
        <v-col v-if="saveData.uc_type == 'C'" cols="12" md="3" class="pl-3 py-0">
          <v-label> Message Use </v-label>
        </v-col>
        <v-col v-if="saveData.uc_type == 'C'" cols="12" md="9" class="pr-3 py-0">
          <v-checkbox
            v-model="messageUse"
            @change="changeMessageUse(messageUse)"
            dense
            hide-details
            style="padding-top: 0px !important; margin-top: 0px"
          ></v-checkbox>
        </v-col>
        <v-col v-if="saveData.uc_type == 'C'" cols="12" md="12" class="px-3 py-0">
          <v-form ref="formHttpHeaders" class="form-identification pr-0 pb-6">
            <v-row
              class="ml-0 mr-0 edi-identification-right"
              v-for="(item, index) in listRequests.slice(1)"
              :key="item.id"
            >
              <v-col cols="12" md="7" class="pa-0">
                <v-tooltip top :disabled="!item.isValidateParam">
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <v-text-field
                        :ref="'RQ_' + item.id"
                        solo
                        hide-details
                        v-model="item.keyRequest"
                        @change="validateParam(item)"
                        :rules="[validationUtils.required]"
                        :disabled="!$auth.manage"
                        readonly
                      ></v-text-field>
                    </div>
                  </template>
                  <span v-html="$t('lbl.userSimulator.validDuplicateParam')"></span>
                </v-tooltip>
              </v-col>
              <v-col cols="12" md="4" class="pa-0 pl-4">
                <v-text-field
                  :ref="'RQ_' + item.id + '_' + item.id"
                  solo
                  hide-details
                  v-model="item.valueRequest"
                  :disabled="!$auth.manage"
                  readonly
                ></v-text-field>
              </v-col>
              <v-col cols="12" md="1" class="pa-0 mt-4 text-right">
                <v-icon dense :disabled="!$auth.manage" readonly @click="removeRequest(index)">
                  mdi-minus
                </v-icon>
              </v-col>
            </v-row>
          </v-form>
        </v-col>
        <v-col cols="12" v-if="saveData.uc_ver">
          <a
            class="link-file-text expand-collapse-text"
            @click="
              $cookies.get('comp-id') === $cookies.get('ownr-id') ? openMapperVersion() : null
            "
            >Version {{ saveData.uc_ver }}</a
          >
        </v-col>
      </v-row>
    </v-form>
    <discardChange
      ref="confirmDialog"
      detail="Discard Changes?"
      :showCancel="true"
      color="information"
      size="max"
      title="confirmDialog"
      @select-confirm="removeDialog()"
    ></discardChange>
    <dialogWindow
      ref="RegisteredSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['User', 'created'])"
      color="success"
    ></dialogWindow>
    <dialogWindow
      ref="ModifiedSuccess"
      size="max"
      :detail="$t('msg.common.success.detail', ['User', 'modified'])"
      color="success"
    ></dialogWindow>
  </dialog-drag>
</template>

<script>
import $ from 'jquery';
import EventBus from '@/vue-caas/views/process/component/event-bus.js';
import DialogDrag from '@/vue-dlb/components/vue-dialog-drag.vue';
import discardChange from '@/vue-dlb/components/DiscardChange.vue';
import IconSvg from '@/vue-caas/components/IconBase.vue';
import dialogWindow from '@/vue-dlb/components/NewDialog.vue';
import { getEditData } from '@/vue-caas/utils/process';

export default {
  props: {
    id: String,
    options: Object,
    closeDialog: Function,
    dragStart: Function,
    dragEnd: Function,
    manage: {
      default: false,
    },
  },
  components: {
    dialogWindow,
    DialogDrag,
    discardChange,
    IconSvg,
  },
  data() {
    return {
      procIconSize: 16,
      isHistory: false,
      comId: '',
      nodeId: '',
      comTp: 'USR',
      loadFormData: {},
      userDisable: false,
      saveData: {
        uc_id: '',
        uc_name: '',
        uc_file_name: '',
        uc_type: '',
        uc_conv_req: {},
        uc_file_id: '',
        uc_file_comment: '',
      },
      lastFoldIdInput: '',
      lastFoldIdScript: '',
      types: [
        { text: 'As Connector', value: 'R' },
        { text: 'As Converter', value: 'C' },
      ],
      checkType: '',
      listRequests: [],
      messageUse: false,
      isDuplicatePattern: false,
      setPattern: new Set(),
    };
  },
  computed: {
    getUserDisable() {
      return this.userDisable;
    },
    userList() {
      return this.$store.getters.userComponentSelectBoxList;
    },
  },
  created() {
    this.initialize();
    EventBus.$on('check-right-layer-change', this.closeComDialog);
  },
  methods: {
    changeComponentData() {
      this.changeUser(this.comId);
    },
    openMapperVersion() {
      EventBus.$emit('open-user-component-version', this.saveData);
    },
    resetSetPattern() {
      this.setPattern.clear();
      this.listRequests.map((item) => {
        if (item.keyRequest !== '') {
          this.setPattern.add(item.keyRequest);
        }
      });
    },
    validateParam(itemChange) {
      let indexValid = this.listRequests.findIndex((e) => e.id === itemChange.id);
      if (this.setPattern.has(itemChange.keyRequest)) {
        this.isDuplicateParam = true;
        this.listRequests[indexValid].isValidateParam = true;
      } else {
        this.isDuplicateParam = false;
        this.listRequests[indexValid].isValidateParam = false;
      }
      this.resetSetPattern();
    },
    changeMessageUse(messageUse) {
      this.listRequests[0].valueRequest = messageUse.toString();
    },
    onFileChanged(e) {
      this.saveData.file_id = e[0].FILE_ID;
      this.saveData.uc_file_name = e[0].FILE_NAME;
    },
    openLoadFilePop(data) {
      let { mode, filetype } = data;
      let callback = (row) => {
        Store.dispatch('common/viewFileData', row.FILE_ID).then(() => {});
      };
      this.$emit('openLoadFile', {
        mode: 'Load',
        filetype: filetype,
        lastFoldIdInput: this.lastFoldIdInput,
        lastFoldIdScript: this.lastFoldIdScript,
        callback,
      });
    },
    convertArrayObjectToJson(listObject) {
      let jsonFormat;
      if (listObject.length > 0) {
        jsonFormat = listObject.reduce(
          (obj, item) => Object.assign(obj, { [item.keyRequest]: item.valueRequest }),
          {},
        );
      } else {
        jsonFormat = {};
      }
      return jsonFormat;
    },
    onSave() {
      if (this.isDuplicateParam) {
        this.$refs.DuplicatePatternDialog.dialog = true;
        return -1;
      }
      let indexValid = this.listRequests.findIndex(
        (e) => e.keyRequest === '' || e.valueRequest === '',
      );
      if (indexValid > -1) {
        let itemRequest = this.listRequests[indexValid];
        this.$refs[
          `RQ_${itemRequest.id}${itemRequest.keyRequest === '' ? '' : '_' + itemRequest.id}`
        ][0].focus();
        return -1;
      }
      let validResult = this.$refs.form.validate();
      if (validResult) {
        this.listRequests.map((e) => (e.keyRequest += '_|_' + e.id));
        this.saveData.uc_conv_req = this.convertArrayObjectToJson(this.listRequests);
        showProgress();
        if (this.options.item.action == 'Add') {
          this.$store
            .dispatch('insertUserComponent', this.saveData)
            .then(() => {
              hideProgress();
              this.removeDialogRefesh({});
            })
            .catch(() => {
              hideProgress();
            });
        } else {
          this.$store
            .dispatch('updateUserComponent', this.saveData)
            .then(() => {
              hideProgress();
              this.removeDialogRefesh({});
            })
            .catch(() => {
              hideProgress();
            });
        }
      } else {
        return validResult;
      }
    },
    removeDialogRefesh(dialog) {
      dialog.id = this.id;
      this.closeDialog(dialog);
      EventBus.$emit('refeshListUserComponent');
    },
    removeWariningDialog(dialog) {
      this.$refs.DuplicatePatternDialog.dialog = false;
    },
    addRequest() {
      let index =
        this.listRequests.length > 0 ? this.listRequests[this.listRequests.length - 1].id + 1 : 1;
      this.listRequests.push({
        id: index,
        keyRequest: '',
        valueRequest: '',
        isValidateParam: false,
      });
    },
    removeRequest(index) {
      this.listRequests.splice(index, 1);
      this.resetSetPattern();
    },
    initialize() {
      if (this.options.item.data.comId) {
        this.options.item.action == 'Modify';
      } else {
        this.options.item.action == 'Add';
      }
      this.nodeId = this.options.item.data.nodeId;
      this.comTp = this.options.item.data.comTp;
      if (this.options.item.isHistory) this.isHistory = this.options.item.isHistory;
      this.userDisable = this.options.item.data.userDisable;
      this.changeUser(this.options.item.data.comId);
    },
    changeUser(id) {
      if (this.$refs.form) this.$refs.form.resetValidation();
      this.listRequests = [];
      this.checkType = '';
      this.messageUse = false;
      this.isDuplicatePattern = false;
      this.setPattern = new Set();
      let index = this.userList.findIndex((e) => e.uc_id == id);
      if (index > -1 && (this.manage || this.isHistory)) {
        this.saveData = Object.assign({}, this.userList[index]);
        this.loadFormData = Object.assign({}, this.userList[index]);
        this.comId = Object.assign({}, this.userList[index]);
        if (this.saveData.uc_type == 'C') {
          Object.entries(this.saveData.uc_conv_req).forEach(([key, value], index) => {
            let item = key.split('_|_');
            this.listRequests.push({
              id: item[1],
              keyRequest: item[0],
              valueRequest: value,
            });
          });
        }
        this.listRequests.sort(function(a, b) {
          return b.id > a.id ? -1 : 1;
        });
        let indexMessUse = this.listRequests.findIndex((e) => e.keyRequest === 'attachFile');
        if (indexMessUse > -1)
          this.messageUse = this.listRequests[indexMessUse].valueRequest === 'true';
        this.checkType = this.saveData.uc_type == 'R' ? 'As Connector' : 'As Converter';
        EventBus.$emit('change-component-data', id, this.nodeId);
      } else {
        this.saveData = {
          uc_id: '',
          uc_name: '',
          uc_file_name: '',
          uc_type: '',
          uc_conv_req: {},
          uc_file_id: '',
          uc_file_comment: '',
        };
        this.listRequests.push({
          id: 0,
          keyRequest: 'attachFile',
          valueRequest: 'false',
          isValidatePattern: false,
        });
        this.setPattern.add('attachFile');
        EventBus.$emit('change-component-data', '', this.nodeId);
      }
    },
    closeComDialog() {
      this.checkDataChange();
    },

    checkDataChange() {
      let editedData = getEditData(this.saveData, this.loadFormData);
      if (Object.keys(editedData).length !== 0) {
        this.$refs.confirmDialog.dialog = true;
      } else {
        this.removeDialog();
      }
    },
    removeDialog() {
      this.closeDialog(this.id);
    },
    selectDialog(obj) {
      this.dragStart(obj);
    },
    dialogDragEnd(obj) {
      this.dragEnd(obj);
    },
  },
};
</script>

<style></style>
